import "./LandingFooter.scss";
import React from "react";
import { IonFooter } from "@ionic/react";
import moment from "moment";
import p from "../../../package.json";
import { Link } from "react-router-dom";

interface Props {
  hidden?: boolean;
}

const LandingFooter: React.FC<Props> = ({ hidden = false }) => {
  return (
    <IonFooter className="landing-footer" hidden={hidden}>
      <div className="terms-conditions-and-privacy-policy-hint">
        To learn how Verifier works without collecting your data, read our{" "}
        <Link
          className="terms-and-conditions"
          to="/public/terms-and-conditions"
        >
          Terms & Conditions
        </Link>{" "}
        and{" "}
        <Link className="privacy-policy" to="/public/privacy-policy">
          Privacy Policy
        </Link>
        .
      </div>
      <div className="app-version">
        © {moment().format("YYYY")} Abaxx Technologies | ver {p.version}
      </div>
    </IonFooter>
  );
};

export default LandingFooter;
